module.exports = {
  admin: {
    login: "/admin/login",
    forgotPassword: "/admin/forgot-password",
    privacyPolicy: "/admin/Content/privacy-policy",
    termsAndCondition: "/admin/Content/terms-and-condition",
    changePassword: "/admin/change-password",

    adminUsersList: "/admin/users",
    createAdminUser: "/admin/user/register",
    updateAdminUser: "/admin/user/update/",
    deleteAdminUser: "/admin/user/delete/",
    restoreAdminUser: "/admin/user/restore/",

    connectorList: "/admin/connector",
    createConnector: "/admin/connector/create",
    updateConnector: "/admin/connector/update/",
    deleteConnector: "/admin/connector/delete/",

    brandList: "/admin/brand",
    createBrand: "/admin/brand/create",
    updateBrand: "/admin/brand/update/",
    deleteBrand: "/admin/brand/delete/",

    chargerList: "/admin/charger",
    unassignedChargerList: "/admin/charger/unassigned",
    createCharger: "/admin/charger/create",
    updateCharger: "/admin/charger/update/",
    deleteCharger: "/admin/charger/delete/",

    fleetClientList: "/admin/fleet-client/",
    fleetClientSearch: "/admin/fleet-client/search",
    createFleetClient: "/admin/fleet-client/create",
    fleetClientDetails: "/admin/fleet-client/",
    updateFleetClient: "/admin/fleet-client/update/",
    deleteFleetClient: "/admin/fleet-client/delete/",
    restoreFleetClient: "/admin/fleet-client/restore/",

    fleetVehicleList: "/admin/fleet-vehicle/list",
    fleetVehicleSearch: "/admin/fleet-vehicle/search",
    createFleetVehicle: "/admin/fleet-vehicle/create",
    fleetVehicleDetails: "/admin/fleet-vehicle/",
    updateFleetVehicle: "/admin/fleet-vehicle/update/",
    deleteFleetVehicle: "/admin/fleet-vehicle/delete/",
    restoreFleetVehicle: "/admin/fleet-vehicle/restore/",

    chargingStationList: "/admin/charging-station",
    createChargingStation: "/admin/charging-station/create",
    updateChargingStation: "/admin/charging-station/update/",
    deleteChargingStation: "/admin/charging-station/delete/",
    restoreChargingStation: "/admin/charging-station/restore/",
    unassignedChargingStation: "/admin/charging-station/unassigned",
    unassignedFeeChargingStation: "/admin/fee/unassigned",

    rolesList: "/admin/role",
    createRole: "/admin/role/create",
    updateRole: "/admin/role/update/",
    deleteRole: "/admin/role/delete/",

    permissionList: "/admin/permissions",

    amenityList: "/admin/amenity",
    createAmenity: "/admin/amenity/create",
    updateAmenity: "/admin/amenity/update/",
    deleteAmenity: "/admin/amenity/delete/",

    vehicleList: "/admin/vehicles",
    createVehicle: "/admin/vehicles/create",
    updateVehicle: "/admin/vehicles/update/",
    deleteVehicle: "/admin/vehicles/delete/",
    restoreVehicle: "/admin/vehicles/restore/",

    endUserList: "/admin/enduser",
    deleteEndUser: "/admin/enduser/delete/",
    restoreEndUser: "/admin/enduser/restore/",

    bookingList: "/admin/booking",
    cancelBooking: "/admin/booking/cancel/",

    reviewList: "/admin/review",
    updateReview: "/admin/review/update/",

    feeList: "/admin/fee",
    createFee: "/admin/fee/create",
    updateFee: "/admin/fee/update/",
    deleteFee: "/admin/fee/delete/",

    convenienceFee: "/admin/convenience-fee",
    updateConvenienceFee: "/admin/convenience-fee/update",
    updateGST: "/admin/gst/update",

    downloadBulkUploadTemplate: "/admin/bulk-upload/get-sheet/vehicles",
    uploadBulkUploadFile: "/admin/bulk-upload/upload-vehicles",

    dashboardCounts: "/admin/dashboard/counts",
    dashboardChargerStatus: "/admin/dashboard/charger-chart",
    dashboardVehicleStatus: "/admin/dashboard/vehicles-chart",
    dashboardEnergyDispensed: "/admin/dashboard/energy-dispensed-chart",
    dashboardTopPerformingChargingStation:
      "/admin/dashboard/top-performing-status",

    stopTransaction: "/api/admin/stop-transaction",
    startTransaction: "/api/admin/start-transaction",
  },
}
